﻿const axios = require('axios');

class NewBillingAddress {

    Init() {
        var vm = this;
        if ($("#MarketsWithStates").length > 0) {
            vm.countriesWithStates = $("#MarketsWithStates").val().split(',');
            vm.countriesWithStatesRequired = $("#MarketsWithStatesRequired").val().split(',');
        }
        
        vm.$stateDropdown = $("#BillingAddress_StateProvinceCode");
        vm.$stateNameTxt = $("#BillingAddress_StateProvinceName");
        vm.$stateError = $("#BillingStateProvinceError");
        vm.$countryCodeOption = null;

        vm.$billingLine1Error = $('#BillingLine1Error');
        vm.$billingCityError = $('#BillingCityError');
        vm.$billingStateProvinceError = $('#BillingStateProvinceError');
        vm.$billingPostalCodeError = $('#BillingPostalCodeError');
        vm.$billingCountryError = $('#BillingCountryError');

        $('.jsUsersNewBillingAddressBtn').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                vm.addNewBillingAddress($(this));
            });
        });
        $('.NewBillingCountryChanged').each(function (i, e) {
            $(e).change(function (event) {
                //event.preventDefault();
                vm.CountryChangedIndex($(this));
            });
        });
    }

    convertToJsonObject(arrayData) {
        var indexed_array = {};

        $.map(arrayData, function (n, i) {
            indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
    }

    getCountryCode(){
        var val = $("#BillingAddress_CountryCode option:selected").val();
        return val;
    }

    getCountryName() {
        var text = $("#BillingAddress_CountryCode option:selected").text();
        return text;
    }

    getStateProvinceName() {
        var text = $("#BillingAddress_StateProvinceCode option:selected").text();
        return text;
    }

    CountryChangedIndex(e) {

        var vm = this;
        var countryCode = vm.getCountryCode();
        var found = vm.countriesWithStates.includes(countryCode);

        if (found) {
            vm.getStateProvince(vm.$stateDropdown, vm.$stateNameTxt, countryCode);
        }
        else {
            vm.$stateDropdown.find('option').remove().end();
            vm.$stateNameTxt.show();
            vm.$stateDropdown.hide();;
            vm.$stateError.innerText = "";
        }
    }

    addNewBillingAddress(e) {
        var vm = this;
        let form = $(e).closest("form")[0];
        let bodyFormData = new FormData(form);

        bodyFormData.set('BillingAddress.CountryName', vm.getCountryName());
        bodyFormData.set('BillingAddress.StateProvinceName', vm.getStateProvinceName());
        
        
        $('.loading-box').show();
        axios({
            method: 'post',
            url: form.action,
            data: bodyFormData,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .then(function (response) {
                if (response.data) {
                    if (response.data.success) {
                        $(".register").toggle();
                        $(".register-confirmation").toggle();
                    }
                    else {
                        var errorMessage = document.getElementById('login-signup-errormessage');
                     
                        if (errorMessage) {
                            errorMessage.innerText = '';
                            for (var error in response.data.errors) {
                                if (response.data.errors[error].key === "BillingAddress.Line1") {
                                    vm.$billingLine1Error.text(response.data.errors[error].value);
                                    vm.$billingLine1Error.parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "BillingAddress.City") {

                                    vm.$billingCityError.text(response.data.errors[error].value);
                                    vm.$billingCityError.parent().addClass('form-error');
                                }

                                if (response.data.errors[error].key === "BillingAddress.StateProvinceCode") {
                                    var countryCode = vm.getCountryCode();
                                    var found = vm.countriesWithStatesRequired.includes(countryCode);
                                    if (found) {
                                        vm.$billingStateProvinceError.text(response.data.errors[error].value);
                                        vm.$billingStateProvinceError.parent().addClass('form-error');
                                    }
                                    else {
                                        vm.$billingStateProvinceError.text('');
                                        vm.$billingStateProvinceError.parent().removeClass('form-error');
                                    }
                                }
                                
                                if (response.data.errors[error].key === "BillingAddress.PostalCode") {

                                    vm.$billingPostalCodeError.text(response.data.errors[error].value);
                                    vm.$billingPostalCodeError.parent().addClass('form-error');
                                }

                                if (response.data.errors[error].key === "BillingAddress.CountryCode") {
                                    vm.$billingCountryError.text(response.data.errors[error].value);
                                    vm.$billingCountryError.parent().addClass('form-error');
                                }

                                if (vm.$billingLine1Error.text() === '') {
                                    vm.$billingLine1Error.parent().removeClass('form-error');
                                }

                                if (vm.$billingCityError.text() === '') {
                                    vm.$billingCityError.parent().removeClass('form-error');
                                }

                                if (vm.$billingStateProvinceError.text() === '') {
                                    vm.$billingStateProvinceError.parent().removeClass('form-error');
                                }

                                if (vm.$billingPostalCodeError.text() === '') {
                                    vm.$billingPostalCodeError.parent().removeClass('form-error');
                                }

                                
                                if (vm.$billingCountryError.text() === '') {
                                    vm.$billingCountryError.parent().removeClass('form-error');
                                }

                                if (response.data.errors[error].key === 'Register.ContactExist') {
                                    errorMessage.style.display = "block";
                                    $('#login-signup-errormessage').append(response.data.errors[error].value + '<br />');
                                }

                                if (response.data.errors[error].key === undefined || response.data.errors[error].key === '') {
                                    errorMessage.style.display = "block";
                                    $('#login-signup-errormessage').append(response.data.errors[error] + '<br />');
                                }
                            }
                        }
                    }
                }
                else {
                    
                    window.location.href = '/';
                }
            })
            .catch(function (response) {
                
                var errorPanel = document.getElementById('login-signup-errormessage');
                errorPanel.innerText = response;
                errorPanel.style.display = "block";
            })
            .finally(function () {
                $('.loading-box').hide();
            });
    }


    getStateProvince($stateDropdown, $stateNameTxt, countryCode) {
        var vm = this;
        axios.post('/api/edit-addresses/stateprovinces', { 'countryCode': countryCode }).then(response => {
            $stateDropdown.find('option').remove().end();
            $stateDropdown.append($('<option text="" value=""></option>'));
            $.each(response.data.items, function (i, item) {
                $stateDropdown.append($('<option>', {
                    value: item.value,
                    text: item.text
                }));
            });
            $stateDropdown.show();
            $stateNameTxt.hide();
        }, error => {
            if (error.response.status === 422) {
                vm.$store.commit('setEndpointErrors', error.response.data.errors);
            }
        });
    }
}



$(document).ready(function () {
    var newBillingAddress = new NewBillingAddress();
    newBillingAddress.Init();
});